export enum PlacementPositions {
  LEFT = "left",
  RIGHT = "right",
  TOP = "top",
  TOP_RIGHT = "topRight",
  TOP_LEFT = "topLeft",
  BOTTOM = "bottom",
  VERTICAL = "vertical",
  BOTTOM_RIGHT = "bottomRight",
  RIGHT_BOTTOM = "rightBottom",
  RIGHT_TOP = "rightTop",
  BOTTOM_LEFT = "bottomLeft",
  LEFT_BOTTOM = "leftBottom",
  LEFT_TOP = "leftTop",
}
